import React, { useState } from "react";

import { VideoPreviewContext } from "./VideoPreviewContext";

export const VideoPreviewProvider: React.FC = ({ children }) => {
    const [rewindTimestamp, setRewindTimestamp] = useState<number>(0);
    const [currentTimestamp, setCurrentTimestamp] = useState<number>(0);
    const [videoDuration, setVideoDuration] = useState<number>(0);

    return (
        <VideoPreviewContext.Provider
            value={{
                rewindTimestamp,
                currentTimestamp,
                videoDuration,
                setCurrentTimestamp,
                setRewindTimestamp,
                setVideoDuration
            }}
        >
            {children}
        </VideoPreviewContext.Provider>
    );
};
